<!--general container begin-->
<div class="w-full p-2 flex relative">
    <!--pdf document displaying field (Left Field) begin-->
    <div class="p-1 mr-2">
        <!--Loading scene begin-->
        <div class="shadow-2 relative p-3 border-round-2xl overflow-hidden"
             style="width: 60rem;"
             *ngIf="documentData?.length === 0 || !documentData">
            <p-skeleton height="75rem" class="w-full" styleClass="w-full"></p-skeleton>
            <div class="absolute w-full h-30rem flex flex-column align-items-center pt-5 mt-8 z-5 top-0 left-0">
                <i class="pi pi-file text-8xl text-gray-300"></i>
                <div
                    class="text-2xl text-gray-300 py-3">{{ 'sipo.sign-task-details-component.document-preview' | translate }}
                </div>
                <div
                    class="text-2xl text-gray-200">{{ 'sipo.sign-task-details-component.pdf-will-be-displayed-here' | translate }}
                </div>
            </div>
        </div>
        <!--Loading scene end-->
        <!--Loaded document begin-->
        <div class="shadow-2 p-3 border-round-2xl" *ngIf="documentData.length > 0">
            <!--top field begin-->
            <div id="left-content-top-field" class="flex justify-content-between align-items-center mb-4">
                <div class="flex align-items-center">
                    <div class="p-3 bg-red-100 border-round-lg">
                        <i class="pi pi-file-pdf text-3xl text-red-600"></i>
                    </div>
                    <div class="flex flex-column ml-2">
                        <span class="text-2xl font-bold">{{ signProcess?.fileName }}</span>
                        <span class="text-gray-500">
                            {{ documentData.length }} {{ 'sipo.sign-task-details-component.pages' | translate }}
                            </span>
                    </div>
                </div>
                <!--top right process state badge begin-->
                <!--                <div class="flex bg-yellow-200 text-red-400 align-items-center p-2 border-round font-semibold"-->
                <!--                     *ngIf="!isAllSignersSigned">-->
                <!--                    <i class="pi pi-clock mr-2 font-semibold"></i>-->
                <!--                    <span>{{ 'sipo.sign-task-details-component.waiting-message' | translate }}</span>-->
                <!--                </div>-->
                <!--                <div class="flex bg-green-200 text-green-700 align-items-center p-2 border-round font-semibold"-->
                <!--                     *ngIf="isAllSignersSigned">-->
                <!--                    <i class="pi pi-check mr-2 font-semibold"></i>-->
                <!--                    <span>{{ 'sipo.sign-task-details-component.all-signed-message' | translate }}</span>-->
                <!--                </div>-->
                <!--top right process state badge end-->
            </div>
            <!--top field end-->
            <!--middle field begin-->
            <!--middle field begin-->
            <div id="pdf-images" class="mb-0" style="width: 768px;">
                <!-- Jede Seite bekommt einen eigenen Container als Positionier-Kontext -->
                <div class="pdf-page" *ngFor="let doc of documentData; let idx = index">
                    <img
                        [src]="doc.img"
                        class="border-1 page-img"
                        width="100%"
                        #pageImg
                        (load)="onPageImgLoad(idx + 1, pageImg)"
                        alt="PDF page"
                    />

                    <!-- Signaturen NUR für diese Seite (pageNumber == idx+1) -->
                    <ng-container *ngFor="let pos of positionsForPage(idx + 1)">
                        <div
                            class="signature"
                            [style.top.px]="scaleY(pos)"
                            [style.left.px]="scaleX(pos) - 3"
                        >
                            <app-id-card
                                [name]="pos?.signer"
                                [signType]="signProcess?.signingType ?? ''"
                                [customWidth]="15"
                                [dynamicNameFontDevideNumber]="20"
                                optionalLine1=""
                                optionalLine2="">
                            </app-id-card>
                        </div>
                    </ng-container>
                </div>
            </div>
            <!--middle field end-->

            <!--middle field end-->
        </div>
        <!--Loaded document end-->
    </div>
    <!--pdf document displaying field (Left Field) end-->

    <!--Sign process details displaying field (Right Field) begin-->
    <div class="p-1 mr-2 ">

        <!--Loading scene begin-->
        <div class="shadow-2 p-3 border-round-2xl overflow-hidden w-30rem"
             *ngIf="!signProcess || documentData?.length === 0 || !documentData">
            <p-skeleton height="50rem" class="w-full" styleClass="w-full"></p-skeleton>
        </div>
        <!--Loading scene end-->

        <!--Loaded data displaying begin-->
        <div class="w-full fixed-menu " *ngIf="signProcess && documentData.length > 0 && documentData">

            <!--Topic and information message begin-->
            <div class="mb-5">
                <div class="flex align-items-center pb-3">
                    <div
                        class="text-5xl font-bold text-gray-700">{{ 'sipo.document-signing-component.signature-details' | translate }}
                    </div>
                    <div *ngIf="signingState">
                        <i class="pi pi-check-square ml-3 text-5xl font-bold text-green-500"></i>
                    </div>
                </div>
                <span class="text-center text-lg font-bold">
            {{ 'sipo.document-signing-component.document-check-message' | translate }}
          </span>
            </div>
            <!--Topic and information message end-->

            <!--Sign button begin-->
            <div>
                <button class="p-button flex justify-content-center my-5 py-4 w-12" (click)="signDocumentItemSign()"
                        *ngIf="!signingState">
                    {{ 'sipo.document-signing-component.sign-the-document' | translate }}
                </button>
<!--                <button class="p-button flex justify-content-center my-5 py-4 w-12" (click)="signDocumentItemSign()"-->
<!--                        *ngIf="!signingState">-->
<!--                    {{ 'sipo.document-signing-component.sign-the-document' | translate }}-->
<!--                </button>-->
                <div
                    class="p-button bg-transparent text-lg font-bold text-gray-500 flex justify-content-center my-5 py-4 w-12"
                    *ngIf="signingState">
                    {{ 'sipo.document-signing-component.you-already-signed-the-document' | translate }}
                </div>
            </div>
            <!--Sign button end-->

            <!--signature type (evidence) card begin-->
            <div class="shadow-2 border-round-2xl mb-4 relative">
                <div class="p-3">
                    <div
                        class="text-lg font-semibold">{{ 'sipo.sign-task-details-component.signature-type' | translate }}
                    </div>
                    <div
                        class="my-3 p-3 border-red-500 text-red-500 border-1 bg-red-50 border-round-xl flex align-items-center justify-content-between">
                        <div class="flex align-items-center">
                            <i class="pi pi-circle-fill"></i>
                            <span
                                class="ml-3">{{ 'sipo.evidences-short.' + signProcess?.signingType | translate }}</span>
                            <span
                                class="ml-3 text-gray-500">{{ 'sipo.id-card-component-evidence.' + signProcess?.signingType | translate }}</span>
                        </div>
                    </div>
                    <div class="flex align-items-center text-red-500 my-3">
                        <i class="pi pi-shield text-xl font-semibold"></i>
                        <span *ngIf="signProcess?.signingType === 'basic'"
                              class="ml-2 text-xl font-semibold">
                        {{ 'sipo.sign-task-details-component.basic-security' | translate }}
                    </span>
                        <span *ngIf="signProcess?.signingType === 'basiccert'"
                              class="ml-2 text-xl font-semibold">
                        {{ 'sipo.sign-task-details-component.mid-security' | translate }}
                    </span>
                        <span *ngIf="signProcess?.signingType === 'high'"
                              class="ml-2 text-xl font-semibold">
                        {{ 'sipo.sign-task-details-component.high-security' | translate }}
                    </span>
                        <span *ngIf="signProcess?.signingType === 'max'"
                              class="ml-2 text-xl font-semibold">
                        {{ 'sipo.sign-task-details-component.max-security' | translate }}
                    </span>
                    </div>
<!--                    <div class="text-gray-500">elDas konform - Rechtsgültig in EU</div>-->
                </div>
            </div>
            <!--signature type (evidence) card end-->

            <!--signers list card begin-->
            <div class="shadow-2 border-round-2xl mb-4 overflow-hidden" style="border: 1rem solid rgba(255,255,255,0)">
                <div class="flex align-items-center justify-content-between">
                    <div class="text-lg font-semibold">
                        {{ 'sipo.sign-task-details-component.signers' | translate }}
                    </div>
                </div>
                <!--If there is no signer this field is rendered 'BEGIN'-->
                <div class="flex align-items-center justify-content-between mt-3 py-1"
                     *ngIf="signProcess.signers.length === 0">
                    <span>{{ 'sipo.sign-task-details-component.no-signer-message' | translate }}</span>
                </div>
                <!--If there is no signer this field is rendered 'END'-->

                <div class="flex align-items-center justify-content-between mt-3 py-1 updateSignerInfo"
                     *ngFor="let signer of signProcess.signers; let i = index;"
                     [id]="'updateSignerInfoId'+i">
                    <div class="min-w-full flex align-items-center justify-content-between">
                        <!--signer name and signed info begin-->
                        <div class="flex align-items-center">
                            <div>
                                <i class="pi pi-circle-fill"></i>
                            </div>
                            <div class="ml-2">
                                <div class="font-semibold text-lg">{{ signer.fullName }}</div>
                                <div class="font-semibold text-gray-500 text-lg">{{ signer.email }}</div>
                            </div>
                        </div>
                        <!--signer name and signed info end-->
                    </div>
                </div>
            </div>
            <!--signers list card end-->

            <!--message field begin-->
            <div class="shadow-2 p-3 border-round-2xl mb-4">
                <div class="flex align-items-center justify-content-between">
                    <div class="text-lg font-semibold">{{ 'sipo.sign-task-details-component.messages' | translate }}
                    </div>
                </div>
                <div
                    class="text-gray-500 mt-3 py-1">{{ signProcess.message?.length != 0 ? signProcess.message : 'sipo.no-message-written'|translate }}
                </div>
            </div>
            <!--message field end-->

            <!--Observers field card begin-->
            <div class="shadow-2 border-round-2xl mb-4 overflow-hidden" style="border: 1rem solid rgba(255,255,255,0)">
                <div class="flex align-items-center justify-content-between">
                    <div class="text-lg font-semibold">{{ 'sipo.sign-task-details-component.observers' | translate }}
                    </div>
                </div>
                <div
                    class="text-gray-500 mt-3 py-1">{{ signProcess.observers?.length != 0 ? signProcess.observers : 'sipo.no-observer-selected'|translate }}
                </div>
            </div>
            <!--Observers field card end-->

            <!--Additional Files field card begin-->
            <div class="shadow-2 p-3 border-round-2xl mb-4">
                <div class="flex align-items-center justify-content-between">
                    <div
                        class="text-lg font-semibold">{{ 'sipo.sign-task-details-component.additional-files' | translate }}
                    </div>
                </div>
                <div class="text-gray-500 mt-3 py-1" *ngIf="signProcess.additionalFiles?.length != 0">
                    <div class="flex align-items-center justify-content-between">
                        <ul>
                            <li *ngFor="let af of signProcess.additionalFiles; let i = index" class="py-1">
                                <a href="#" (click)="openInNewTab(af); $event.preventDefault()" class="no-line-break">
                                    {{ af.name }}
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="text-gray-500 mt-3 py-1" *ngIf="signProcess.additionalFiles?.length === 0">
                    {{ 'sipo.sign-task-details-component.no-file-message' | translate }}
                </div>
            </div>
            <!--Additional Files field card end-->

            <!--card 4 begin-->
            <!--            <div class="shadow-2 p-3 border-round-2xl mb-4">-->
            <!--                <div class="text-lg font-semibold">{{ 'sipo.sign-task-details-component.compliance' | translate }}</div>-->
            <!--                <div class="flex align-items-center mt-3">-->
            <!--                    <span>🇩🇪</span>-->
            <!--                    <span class="text-gray-500 ml-2">elDas konform</span>-->
            <!--                </div>-->
            <!--                <div class="flex align-items-center mt-3">-->
            <!--                    <span>🇹🇷</span>-->
            <!--                    <span class="text-gray-500 ml-2">E-imza konform</span>-->
            <!--                </div>-->
            <!--                <div class="flex align-items-center mt-3">-->
            <!--                    <span>🇨🇭</span>-->
            <!--                    <span class="text-gray-500 ml-2">ZertES konform</span>-->
            <!--                </div>-->
            <!--            </div>-->
            <!--card 4 end-->

        </div>
        <!--Loaded data displaying end-->
    </div>
    <!--Sign process details displaying field (Right Field) end-->
</div>
<!--general container end-->
